var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClearfilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17.448,
    viewBox: "0 0 19 17.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_clearfilter",
    d: "M5.273,8.164,0,3.945V3.164H14.836v.781L9.562,8.164v4.213L5.273,15.891Zm5.344,2.911a3.691,3.691,0,1,1,3.691,3.691A3.7,3.7,0,0,1,10.617,11.074Zm4.437,1.491.746-.746-.746-.746.746-.746-.746-.746-.746.746-.746-.746-.746.746.746.746-.746.746.746.746.746-.746ZM0,2.109V0H14.836V2.109Z",
    transform: "translate(0.5 0.5)",
    fill: "white",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClearfilter);
export default __webpack_public_path__ + "static/media/icon_clearfilter.1c6c64bb8154877f6823adc3b99dd0ea.svg";
export { ForwardRef as ReactComponent };